module.exports = __webpack_public_path__ + "img/02-livepen.6765981f.png";